import "../styles/Footer.css";
import logo from '../img/square logo/final.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer-container">

      {/* Back to top */}
      <a className="back-top-btn" onClick={scrollToTop}>
        <FontAwesomeIcon icon={faChevronUp} />
      </a>

      <div className="footer-content">

        {/* LEFT COLUMN */}
        <div className="footer-left">
          <h3 className = "footer-title"><img src = {logo} alt = "Heartline-hk logo" className = "footer-logo" />
          Heartline Hong Kong
          </h3>
          <p className="desc">
            如欲知道更多心理學資訊和了解我們的最新消息，<br />
            請關注我們的社交平台。
          </p>

          <div className="social-icons">
            <a href="https://www.instagram.com/heartlinehk/">
              <FontAwesomeIcon icon={faInstagram} />
              </a>
            <a href="https://www.linkedin.com/company/mentalsos/">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="https://www.facebook.com/heartlinehongkong">
              <FontAwesomeIcon icon={faFacebookSquare} />
            </a>
            <p className="email">
            <a href="mailto:info@heartlinehk.com">info@heartlinehk.com</a>
          </p>
          </div>

          <div className="footer-bottom">
            <Link to="/terms-and-conditions" className="terms-and-conditions">
              服務條款
            </Link>
            {" · "}
            <Link to="/privacy-terms" className="terms-and-conditions">
              私隱政策
            </Link>

            <p className="copyright">© 2025 Heartline Hong Kong Limited</p>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="footer-right">
        <h4>捐助機構（按字母排序）</h4>
        <ul>
          <li>
            <a href = "https://www.chickensoupfoundation.org/">
              ChickenSoup Foundation
            </a>
          </li>
            <li>
            <a href="https://www.ws.cuhk.edu.hk/dare/">
                CUHK Lee Woo Sing College Dare Scheme
            </a>
            </li>
            <li>
            <a href="https://www.na.cuhk.edu.hk/college-life/scholarships-and-subsidies/funding-support-for-student-activities/">
                CUHK New Asia College Student Activities Fund
            </a>
            </li>
            <li>
            <a href="https://www.psy.cuhk.edu.hk/index.php/undergraduate/psy-connection-award">
                CUHK Psy-connection Award
            </a>
            </li>
            <li>
            <a href="https://www.csifund.org/en">
                HKBN Talent CSI Fund
            </a>
            </li>
            <li>
            <a href="https://commoncore.hku.hk/experiential-learning/">
                HKU Common Core Transdisciplinary Experiential Learning Fund
            </a>
            </li>
            <li>
            <a href="https://www.icsd-global.org/">
                International Chamber of Sustainable Development
            </a>
            </li>
            <li>
            <a href="https://www.petersonhk.com/sustainability/peterson-foundation/">
                Peterson Group Charity Foundation Limited
            </a>
            </li>
            <li>
            <a href = "https://shcc.edu.hk/">
            Sacred Heart Canossian College
            </a>
            </li>
        </ul>
        </div>


      </div>
    </footer>
  );
};

export default Footer;